module.exports = __webpack_public_path__ + "static/img/demo-team.edc6bbb5.png";